import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import PickupLocation from '~/types/PickupLocation';

export type PickupsState = {
  readonly pickupsLocation: Maybe<PickupLocation>;
  readonly buildingLocationTypes: PickupLocation[];
  readonly totalWeight: number;
  readonly totalTransactions: number;
  readonly transactionObjectIds: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly serviceLevelInfo: any;
  readonly carrierAccountId: Maybe<string>;
  readonly confirmationCode: Maybe<string>;
  readonly pickupDate: Maybe<string>;
  readonly pickupReadyByTime: Maybe<string>;
  readonly timeZone: Maybe<string>;
  readonly carrier: Maybe<string>;
  readonly pickupSuccess: boolean;
  readonly pickupPending: boolean;
  readonly isLoading: boolean;
};

const initialState: PickupsState = {
  pickupsLocation: null,
  buildingLocationTypes: [],
  totalWeight: 0,
  totalTransactions: 0,
  transactionObjectIds: [],
  serviceLevelInfo: {},
  carrierAccountId: null,
  confirmationCode: null,
  pickupDate: null,
  pickupReadyByTime: null,
  timeZone: null,
  carrier: null,
  pickupSuccess: false,
  pickupPending: false,
  isLoading: true,
};

function pickupsReducer(state: PickupsState = initialState, action: ActionTypes): PickupsState {
  switch (action.type) {
    case ActionKeys.PICKUPS_CHANGE_LOCATION:
      return {
        ...state,
        pickupsLocation: {
          name: action.payload.name,
          value: action.payload.value,
        },
      };
    case ActionKeys.PICKUPS_FETCH_TRANSACTIONS:
      return {
        ...state,
        carrier: action.payload.carrier,
      };
    case ActionKeys.PICKUPS_FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        totalWeight: action.payload.totalWeight,
        totalTransactions: action.payload.totalTransactions,
        transactionObjectIds: action.payload.transactionObjectIds,
        serviceLevelInfo: action.payload.serviceLevelInfo,
        isLoading: false,
      };
    case ActionKeys.PICKUPS_FETCH_TRANSACTIONS_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case ActionKeys.PICKUPS_FETCH_CARRIER_ACCOUNT_ID_SUCCESS:
      return {
        ...state,
        carrierAccountId: action.payload.carrierAccountId,
      };
    case ActionKeys.PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES_SUCCESS:
      return {
        ...state,
        buildingLocationTypes: action.payload.map(
          (val) => ({ name: val.name, value: val.name }), // Yes, name in both cases
        ),
      };
    case ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST:
      return {
        ...state,
        pickupPending: true,
      };
    case ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST_SUCCESS:
      return {
        ...state,
        confirmationCode: action.payload.confirmationCode,
        pickupDate: action.payload.pickupDate,
        pickupReadyByTime: action.payload.pickupReadyByTime,
        timeZone: action.payload.timeZone,
        pickupSuccess: true,
        pickupPending: false,
      };
    case ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST_ERROR:
      return {
        ...state,
        pickupSuccess: false,
        pickupPending: false,
      };
    default:
      return state;
  }
}

export default pickupsReducer;
